import { useDispatch } from 'react-redux'
import { useNavigate } from 'react-router-dom'

import { ClaimReservationActions } from '@AppState/claim-reservation'
import DetailsBackground from '@Assets/confirmation-background.png'
import { Button } from '@Components/button/button'
import { Header } from '@Components/header/header'
import { ImageBackgroundSection } from '@Components/image-background-section/image-background-section'

import './status-screen.scss'

const CLASS_NAME = 'status-screen'

export const AlreadyCancelledScreen = () => {
  const navigate = useNavigate()
  const dispatch = useDispatch()
  return (
    <>
      <Header title="Schedule an Appointment" />
      <section>
        <ImageBackgroundSection backgroundUrl={DetailsBackground}>
          <h3>This appointment has already been cancelled.</h3>
        </ImageBackgroundSection>
        <section className={`${CLASS_NAME}__cta-section`}>
          <Button
            onClick={() => {
              dispatch(ClaimReservationActions.clearSavedReservation())
              navigate(`/create${location.search}`)
            }}>
            Schedule New Appointment
          </Button>
          <Button onClick={() => {}}>Cancel</Button>
        </section>
      </section>
    </>
  )
}
